module.exports = __webpack_public_path__ + "img/xiangmu5.66a69433.png";